<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <b-row>
        <b-col cols="12">
          <h2>Edit Role: {{ role.display_name }}</h2>
        </b-col>
      </b-row>
      <b-card>
        <validation-observer ref="instancesRules">
          <b-form>
            <b-row class="mb-2">
              <b-col sm="4">
                <b-form-group label="Role Name">
                  <validation-provider
                    #default="{ errors }"
                    name="Role Name"
                    rules="required"
                  >
                    <b-form-input
                      v-model="role.display_name"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Role Name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Instances">
                  <validation-provider
                    #default="{ errors }"
                    name="Instances"
                    rules="required"
                  >
                    <v-select
                      v-model="selectedInstances"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :clearable="false"
                      label="name"
                      multiple
                      :options="instancesOptions"
                      :reduce="option => option.id"
                      :class="{'is-invalid': errors.length > 0 }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

        <h4>Permissions</h4>
        <b-tabs
          pills
          vertical
          nav-class="text-left"
          content-class="pl-5"
        >
          <permission-category-tab
            v-for="(categoryPermissions, categoryName) in role.permissions"
            :key="categoryName"
            :category-name="categoryName"
            :category-permissions="categoryPermissions"
          />
        </b-tabs>

        <b-row>
          <b-col
            cols="12"
            class="w-100 d-flex justify-content-end"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              @click="updateRolePermissions"
            >
              Save changes
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mt-2"
              :to="{ name: 'admin-roles-list'}"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-card>

    </b-overlay>

  </div>

</template>

<script>
import {
  BOverlay,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BTabs,
  BButton,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import useRoleEdit from '@/views/admin/roles/role-edit/useRoleEdit'
import PermissionCategoryTab from '@/views/admin/roles/role-edit/components/PermissionCategoryTab.vue'

export default {
  name: 'RoleEdit',
  components: {
    BOverlay,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BTabs,
    BButton,
    PermissionCategoryTab,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      role: {
        display_name: '',
        permissions: {},
      },
      selectedInstances: [],
      instancesOptions: [],
      required,
    }
  },
  setup() {
    const {
      fetchRole,
      updateRole,
      fetchInstancesList,
    } = useRoleEdit()

    return {
      fetchRole,
      updateRole,
      fetchInstancesList,
    }
  },
  created() {
    this.setRoleData()
  },
  methods: {
    async setRoleData() {
      try {
        this.isLoading = true
        const roleId = this.$router.currentRoute.params.id
        this.role = await this.fetchRole(roleId)
        this.instancesOptions = await this.fetchInstancesList()
        if (this.role.schools) {
          this.selectedInstances = this.role.schools.map(item => item.id)
        }
      } finally {
        this.isLoading = false
      }
    },
    async updateRolePermissions() {
      const isValid = await this.$refs.instancesRules.validate()
      if (!isValid) return

      const payload = {
        display_name: this.role.display_name,
        permissions: this.role.permissions,
        school_ids: this.selectedInstances,
      }
      await this.updateRole(this.role.id, payload)
    },
  },
}
</script>

<style>

</style>
